import dayjs from 'dayjs';

const DATE_FORMATS = {
  YYYY_MM_DD: 'YYYY/MM/DD'
} as const satisfies Record<string, string>;

/**
 * 日付のバリデーションチェック
 * @param date 日付
 * @param formatKey 書式
 * @returns チェック結果
 */
const validDate = (date: string | Date | undefined, formatKey: keyof typeof DATE_FORMATS = 'YYYY_MM_DD') => {
  const format = DATE_FORMATS[formatKey];
  switch (format) {
    case 'YYYY/MM/DD':
      // 空チェック
      if (!date) return false;

      // フォーマット可否チェック
      if (!dayjs(date, DATE_FORMATS[formatKey]).isValid()) return false;

      if (typeof date === 'string') {
        // 文字列長チェック
        if (date.length < 8) return false;

        // 日付存在チェック(2023/02/29の場合：false)
        // 参考：https://qiita.com/kubotak/items/3bbde3c976606493060d
        const year = date.substring(0, 4);
        const month = date.substring(4, 6);
        const day = date.substring(6, 8);
        const formatDate = `${year}/${month}/${day}`;
        if (dayjs(date, format).format(format) !== formatDate) return false;
      }

      return true;
    default:
      // フォーマット無効
      return false;
  }
};

/**
 * 日付の書式変換
 * @param date 日付
 * @param formatKey 書式
 * @returns 変換後の日付
 */
const formatDate = (date: string | Date | undefined, formatKey: keyof typeof DATE_FORMATS = 'YYYY_MM_DD') => {
  if (!validDate(date, formatKey)) return undefined;

  const format = DATE_FORMATS[formatKey];
  return dayjs(date, format).format(format);
};

/**
 * string→Dateへ変換する
 * @param date 日付
 * @param formatKey 書式
 * @returns 変換後の日付
 */
const toDate = (date: string | Date | undefined, formatKey: keyof typeof DATE_FORMATS = 'YYYY_MM_DD') => {
  if (!validDate(date, formatKey)) return undefined;

  const format = DATE_FORMATS[formatKey];
  return dayjs(date, format).toDate();
};

const formatTime = (time: string | undefined): string | undefined => {
  if (!time || time.length !== 4) return undefined;
  const hours = time.substring(0, 2);
  const minutes = time.substring(2, 4);
  return `${hours}:${minutes}`;
};

export const formatUtils = {
  DATE_FORMATS,
  validDate,
  formatDate,
  toDate,
  formatTime
};
